import { render, staticRenderFns } from "./ProfileCustomerCreateModal.vue?vue&type=template&id=10133e2b"
import script from "./ProfileCustomerCreateModal.vue?vue&type=script&lang=js"
export * from "./ProfileCustomerCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports